import { render, staticRenderFns } from "./SetPosterStyle.vue?vue&type=template&id=fcb6424c&scoped=true"
import script from "./SetPosterStyle.vue?vue&type=script&lang=js"
export * from "./SetPosterStyle.vue?vue&type=script&lang=js"
import style0 from "./SetPosterStyle.vue?vue&type=style&index=0&id=fcb6424c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb6424c",
  null
  
)

export default component.exports